<template lang='pug'>
thead.show--bigScreens
  tr
    th.color--greyCharcoal30(:class="type == 'government' ? 'tableTop10-1b' : 'tableTop10-1a'" ) 訊息
    th.tableTop10-2a.text--center.color--greyCharcoal30.tableTop-govPartner(@click="sortByType('govPartner')")
      span 發布機關
      i.tableTop10-arrowIcon.icon-arrow.icon-govPartner
    th.tableTop10-3a.text--center.color--greyCharcoal30.tableTop-updatedAt(@click="sortByType('updatedAt')")
      span 時間
      i.tableTop10-arrowIcon.icon-arrow.icon-updatedAt
    th.tableTop10-4a(v-if="type == 'government'")
</template>
<script>
import { disableSort, initCurrentSortByQueryStr } from '@/plugins/tool.js'
export default {
  props: {
    type: String
  },
  data() {
    return {
      currentSort: null
    }
  },
  mounted() {
    this.currentSort = initCurrentSortByQueryStr(this.$route.query.params)
  },
  methods: {
    sortByType(sortType) {
      var data = {
        type: sortType,
        direction: -1
      }
      if (this.currentSort === null) {
        this.currentSort = data
      } else if (this.currentSort.type === data.type) {
        if (this.currentSort.direction === 0) {
          this.currentSort.direction = -1
        } else if (this.currentSort.direction === -1) {
          this.currentSort.direction = 1
        } else {
          this.currentSort.direction = 0
        }
      } else {
        disableSort(this.currentSort.type)
        this.currentSort = data
      }
      this.$emit("sortByType", this.currentSort)
    }
  }
}
</script>
